import React, { useEffect, useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './CarouselFadeExample.css';


function CarouselFadeExample() {
    const [banners, setBanners] = useState([]);
    const [isMobile, setIsMobile] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768); // Mobile breakpoint
        };

        window.addEventListener("resize", handleResize);
        handleResize(); // initial check

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const fetchBannerImages = async () => {
            try {
                const response = await axios.get(
                    'https://eleganzaestatesolutions.com/api/admin/banner-images'
                );
                // Keep items that have at least bannerImage
                const filtered = response.data.meta.filter(item => item.bannerImage);
                setBanners(filtered);
            } catch (error) {
                console.error('Error fetching banner images:', error);
            }
        };

        fetchBannerImages();
    }, []);

    const handleClick = (propertyTitle) => {
        const firstTwoWords = propertyTitle.split(" ").slice(0, 2).join(" ");
        navigate(`/buyPage?search=${encodeURIComponent(firstTwoWords)}`);
    };

    return (
        <Carousel fade interval={2000}>
            {banners.map((banner, index) => (
                <Carousel.Item key={banner._id || index}>
                    <img
                        onClick={() => handleClick(banner.propertyId.title)}
                        className="d-block w-100"
                        src={isMobile ? (banner.phoneImage || banner.bannerImage) : banner.bannerImage}
                        alt={`Slide ${index + 1}`}
                        style={{
                            height: "100vh",
                            objectFit: isMobile ? "cover" : "contain",
                        }}
                        loading="lazy"
                    />
                </Carousel.Item>
            ))}
        </Carousel>
    );
}
export default CarouselFadeExample;
